/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/reset'
export default icon
